import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZeromqComponent } from './simple-icons-zeromq.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZeromqComponent ],
    exports:      [ SimpleIconsZeromqComponent ],
    bootstrap:    []
})
export class SimpleIconsZeromqModule {}
